export default "__VITE_ASSET__ixcfYJxR__"